module.exports = __webpack_public_path__ + "media/img/icons/favourite-83ad48caddd8d08ef04290406016a76e.png";